import React, { useState } from 'react';
import './create_account_admin.css';
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from '../config.js'; // تأكد من استيراد رابط الـ API

export default function CreateAccountAdmin() {
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "", // تمت إضافة رقم الهاتف
    password: "",
    confirmPassword: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    let newErrors = { ...errors };

    if (name === "name") {
      if (!value) newErrors.name = "الاسم مطلوب";
      else delete newErrors.name;
    }
    if (name === "username") {
      if (!value) newErrors.username = "اسم المستخدم مطلوب";
      else delete newErrors.username;
    }
    if (name === "email") {
      if (!value) newErrors.email = "البريد الإلكتروني مطلوب";
      else if (!/\S+@\S+\.\S+/.test(value)) newErrors.email = "صيغة البريد الإلكتروني غير صحيحة";
      else delete newErrors.email;
    }
    if (name === "phone") {
      if (!value) newErrors.phone = "رقم الهاتف مطلوب";
      else if (!/^\d+$/.test(value)) newErrors.phone = "يجب أن يحتوي على أرقام فقط";
      else delete newErrors.phone;
    }
    if (name === "password") {
      if (!value) newErrors.password = "كلمة المرور مطلوبة";
      else delete newErrors.password;
    }
    if (name === "confirmPassword") {
      if (!value) newErrors.confirmPassword = "تأكيد كلمة المرور مطلوب";
      else if (value !== formData.password) newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
      else delete newErrors.confirmPassword;
    }
    setErrors(newErrors);
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = "الاسم مطلوب";
    if (!formData.username) newErrors.username = "اسم المستخدم مطلوب";
    if (!formData.email) {
      newErrors.email = "البريد الإلكتروني مطلوب";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "صيغة البريد الإلكتروني غير صحيحة";
    }
    if (!formData.phone) {
      newErrors.phone = "رقم الهاتف مطلوب";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "يجب أن يحتوي على أرقام فقط";
    }
    if (!formData.password) newErrors.password = "كلمة المرور مطلوبة";
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "تأكيد كلمة المرور مطلوب";
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setApiError("");

    try {
      const token = localStorage.getItem("access_token");
     // In create_account_admin.js, line 93
     const response = await fetch(`${API_BASE_URL}/users/create-account/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          real_name: formData.name,
          username: formData.username,
          email: formData.email,
          phon_number: formData.phone,
          password: formData.password,
          password_confirm: formData.confirmPassword,
          role: 'admin',
          is_active: true, // تفعيل حساب الأدمن مباشرة
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert("تم إنشاء حساب الأدمن بنجاح!");
        navigate("/admins-profiles"); // التوجيه لصفحة إدارة الأدمن
      } else {
        // استخراج وعرض رسائل الخطأ القادمة من الباك إند
        let errorMsg = "حدث خطأ أثناء إنشاء الحساب.";
        if (typeof data === 'object') {
          errorMsg = Object.entries(data)
            .map(([key, val]) => `${key === 'non_field_errors' ? '' : key + ': '} ${Array.isArray(val) ? val.join(' ') : val}`)
            .join(' | ');
        }
        setApiError(errorMsg);
      }
    } catch (err) {
      setApiError("تعذر الاتصال بالخادم. يرجى التأكد من اتصالك بالإنترنت.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-account-admin-container" dir="ltr">
      <div className="create-account-admin-left">
        {/* تحويل الـ div إلى Form مع إضافة حدث onSubmit */}
        <form className="create-account-admin-form" onSubmit={handleSubmit}>
          <h3 className="create-account-admin-h3">إنشاء حساب</h3>
          
          {/* مساحة لعرض أخطاء السيرفر (مثل: الإيميل مسجل مسبقاً) */}
          {apiError && <div style={{ color: 'red', textAlign: 'right', marginBottom: '10px', marginRight: '20px', fontWeight: 'bold' }}>{apiError}</div>}

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-user create-account-icon"></i>
            <input type="text" placeholder="الاسم الحقيقي" onChange={handleChange} name="name"
              className={errors.name ? "input error" : "input"} />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-circle-user create-account-icon"></i>
            <input type="text" placeholder="اسم المستخدم" onChange={handleChange} name="username"
              className={errors.username ? "input error" : "input"} />
            {errors.username && <span className="error-text">{errors.username}</span>}
          </div>

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-at create-account-icon"></i>
            <input placeholder="البريد الإلكتروني" name="email" onChange={handleChange}
              className={errors.email ? "input error" : "input"} />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-phone create-account-icon"></i>
            <input type="tel" placeholder="رقم الهاتف" name="phone" onChange={handleChange}
              className={errors.phone ? "input error" : "input"} />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-unlock create-account-icon"></i>
            <input type="password" placeholder="كلمة المرور" name="password" onChange={handleChange}
              className={errors.password ? "input error" : "input"} />
            {errors.password && <span className="error-text">{errors.password}</span>}
          </div>

          <div className="create-account-admin-input-group">
            <i className="fa-solid fa-lock create-account-icon"></i>
            <input type="password" placeholder="تأكيد كلمة المرور" name="confirmPassword" onChange={handleChange}
              className={errors.confirmPassword ? "input error" : "input"} />
            {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
          </div>

          {/* تم إزالة حقل الـ Checkbox من هنا */}

          <button className="create-account-admin-submit" type="submit" disabled={loading}>
            {loading ? "جاري الإنشاء..." : "إنشاء الحساب"}
          </button>
        </form>
      </div>
      <div className="create-account-admin-right">
        <img className='syria-logo-create-account-admin-logo' src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="Logo" />
        <h1 className="create-account-admin-title">إنشاء أدمن</h1>
        <h4 className="create-account-admin-sub">وزارة الصحة السورية</h4>
      </div>
    </div>
  );
}